import * as api from "@/api/billing";
import formatDateFilter from "@/utils/formatDateFilter";

const initState = () => ({
  paymentsLoaded: false,
  haveNoPayments: true,
  balance_free: null,
  bonus_balance: null,
  payments: [],
  pending_payments: [],
  reports_list: [],
  sum_refill: null,
  sum_wo: null,
  filter: [],
  page: 1,
  pageSize: 5,
  search_query: "",
  total: null,
  withdrawalConfirmModal: false,
  withdrawalSidePanel: false,
  smsid: null,
  code: null,
  process: "init",
  resend_delay: null,
  successWithdrawal: false,
  payout_transactions: null,
  a_count: null,
  c_count: null,
  // Статусы оплат
  statuses: {
    in_process: {
      label: "В процессе оплаты",
      bgColor: "#FAE6AA",
      textColor: "#B79310",
    },
    success: {
      label: "К оплате",
      bgColor: "#D4F296",
      textColor: "#5E8C00",
    },
    error: {
      label: "Ошибка",
      bgColor: "#F9C1BD",
      textColor: "#A61D1D",
    },
    cancel: {
      label: "Отмена",
      bgColor: "#F9C1BD",
      textColor: "#A61D1D",
    },
  },
});

export default {
  namespaced: true,
  state: initState,
  getters: {
    hasStatusFilter: (state) => state.filter.some((f) => f.field === "status"),
    canWithdraw: (state, getters, rootState, rootGetters) => {
      return !!state.balance_free && state.balance_free > 0 && rootGetters["profile/haveAccessToWithdraw"];
    },
    dateFilter: (state) => {
      const filter = state.filter.find((f) => f.field === "dadd");
      return formatDateFilter(filter);
    },
    statusFilter: (state) => {
      // Здесь статус в поле 'status'
      const filter = state.filter.find((f) => f.field === "status");
      if (filter && filter.filters && filter.filters[0]) {
        return filter.filters[0].value;
      }
      // Дефолтное значение фильтра - all
      return "all";
    },
  },
  mutations: {
    reset: (state) => {
      const initialState = initState();
      Object.keys(initialState).forEach((key) => (state[key] = initialState[key]));
    },
    setDateFilter: (state, payload) => {
      state.filter = state.filter.filter(({ field }) => field !== "dadd");

      const daddFilter = {
        field: "dadd",
        logic: "and",
        filters: [],
      };

      if (payload.start) {
        daddFilter.filters.push({
          operator: "gte",
          value: payload.start,
        });
      }
      if (payload.end) {
        daddFilter.filters.push({
          operator: "lte",
          value: payload.end,
        });
      }

      if (daddFilter.filters.length > 0) {
        state.filter.push(daddFilter);
      }
    },
    setSearchQuery: (state, value) => (state.search_query = value),
    setPage: (state, value) => (state.page = value),
    setPageSize: (state, value) => (state.pageSize = value),
    setTotal: (state, value) => (state.total = value),
    setPayments: (state, value) => (state.payments = value),
    setReportsList: (state, value) => (state.reports_list = value || []),
    setPendingPayments: (state, value) => (state.pending_payments = value || []),
    setStatusFilter: (state, payload) => {
      state.filter = state.filter.filter(({ field }) => field !== "status");

      if (payload && payload !== "all") {
        state.filter.push({
          field: "status",
          logic: "and",
          filters: [
            {
              operator: "eq",
              value: payload,
            },
          ],
        });
      }
    },
    setSumRefill: (state, value) => (state.sum_refill = value),
    setSumWo: (state, value) => (state.sum_wo = value),
    setBalanceFree: (state, value) => (state.balance_free = value),
    setBonusBalance: (state, value) => {
      if (typeof value === 'string') {
        value = Number(value);
        if (Number.isNaN(value)) {
          value = 0;
        }
      }

      state.bonus_balance = value ?? 0;
    },
    // setActiveCount: (state, value) => (state.active_count = value),
    setSeptemberBonus: (state, {a_count, c_count}) => {
      state.a_count = a_count;
      state.c_count = c_count;
    },
    setPaymentsLoaded: (state, value) => (state.paymentsLoaded = value),
    setHaveNoPayments: (state, value) => (state.haveNoPayments = value),
    setWithdrawalSmsId: (state, smsid) => (state.smsid = smsid),
    setWithdrawalCode: (state, code) => (state.code = code),
    setWithdrawalProcess: (state, process) => (state.process = process),
    showWithdrawalConfirmModal: (state, value) => (state.withdrawalConfirmModal = value),
    showWithdrawalSidePanel: (state, value) => (state.withdrawalSidePanel = value),
    showSuccessWithdrawal: (state, value) => (state.successWithdrawal = value),
    setResendDelay: (state, value) => (state.resend_delay = value),
    setPayoutTransactions: (state, value) => (state.payout_transactions = value),
  },
  actions: {
    async getPayments({ commit, state: { page, pageSize, filter, search_query, paymentsLoaded }, rootGetters }) {
      if (!rootGetters["profile/canSeeBilling"]) {
        console.error("access to billing denied");
      }
      const response = await api.getPayments({
        page,
        pageSize,
        filter,
        search_query,
      });
      if (response) {
        commit("setPayments", response.list);
        commit("setPendingPayments", response.pending_payments);
        commit("setTotal", response.total);
        commit("setSumWo", response.sum_wo);
        commit("setSumRefill", response.sum_refill);
        if (!paymentsLoaded) {
          commit("setPaymentsLoaded", true);
        }
      }
      return response;
    },

    async getReportsList({ commit, state: { page, pageSize, filter, search_query }, rootGetters }) {
      if (!rootGetters["profile/canSeeBilling"]) {
        console.error("access to billing denied");
      }
      const response = await api.serverGetReportsList({
        page,
        pageSize,
        filter,
        search_query,
      });
      if (response) {
        commit("setReportsList", response.list);
      }
      return response;
    },

    async getBalance({ commit, rootGetters }) {
      if (!rootGetters["profile/canSeeBilling"]) {
        console.error("access to billing denied");
      }

      const response = await api.getBalance({});
      if (response) {
        commit("setBalanceFree", response.balance_free);
        commit("setSeptemberBonus", response);
        commit("setBonusBalance", response.bonus_balance);
      }
    },

    resetWithdraw({ commit }) {
      commit("setWithdrawalSmsId", null);
      commit("setResendDelay", null);
      commit("setWithdrawalCode", null);
      commit("setWithdrawalProcess", "init");
    },

    // Пока что убираем подтверждение вывода по смс
    async makeWithdraw({ commit, state: { code, smsid, process } }) {
      const res = await api.makeWithdraw({ process, smsid, code });
      if (res) {
        if (process === "init" && res.smsid) {
          commit("setWithdrawalProcess", "apply");
          commit("setWithdrawalSmsId", res.smsid);
          if (res.resend_delay) {
            commit("setResendDelay", res.resend_delay);
          }
          commit("showWithdrawalConfirmModal", true);
        } else {
          // dispatch("resetWithdraw");
          // перенесли сброс в компонент
          commit("showWithdrawalConfirmModal", false);
          commit("showWithdrawalSidePanel", true);
          commit("showSuccessWithdrawal", true);
        }
      }
    },
    async getPayoutTransactions({ commit }, id) {
      const response = await api.getPayoutTransactions(id);
      if (response) {
        commit("setPayoutTransactions", response);
      }
      return response;
    },
  },
};
